import {PublicClientApplication} from '@azure/msal-browser';

const ENTRA_LOGIN_CONFIG_KEY = 'MSP_ENTRA_LOGIN_CONFIG';
const ENTRA_LOGIN_ERROR_KEY = 'MSP_ENTRA_LOGIN_ERROR';

function buildAuthority(authorityBaseUrl, tenant) {
  const base = (authorityBaseUrl || '').replace(/\/+$/, '');
  const t = (tenant || '').replace(/^\/+/, '');
  return t ? `${base}/${t}` : base;
}

function createRequest(entraConfig) {
  const request = {
    scopes: (entraConfig.scopes && entraConfig.scopes.length)
      ? entraConfig.scopes
      : ['openid', 'profile'],
  };
  if (entraConfig.loginHint) {
    request.loginHint = entraConfig.loginHint;
  }
  return request;
}

async function createMsal(entraConfig) {
  const msal = new PublicClientApplication({
    auth: {
      clientId: entraConfig.clientId,
      authority: buildAuthority(entraConfig.authorityBaseUrl, entraConfig.tenant),
      redirectUri: window.location.origin,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
  });
  await msal.initialize();
  return msal;
}

export async function loginWithMicrosoftRedirect(entraConfig) {
  sessionStorage.setItem(ENTRA_LOGIN_CONFIG_KEY, JSON.stringify(entraConfig));
  const msal = await createMsal(entraConfig);
  await msal.loginRedirect({...createRequest(entraConfig), prompt: 'login'});
}

export async function handleMicrosoftRedirect() {
  const rawConfig = sessionStorage.getItem(ENTRA_LOGIN_CONFIG_KEY);
  if (!rawConfig) {
    return null;
  }

  const entraConfig = JSON.parse(rawConfig);
  const msal = await createMsal(entraConfig);

  try {
    const result = await msal.handleRedirectPromise();
    if (!result) {
      return null;
    }
    if (result.accessToken) {
      return result.accessToken;
    }
    msal.setActiveAccount(result.account);
    const tokenResult = await msal.acquireTokenSilent(createRequest(entraConfig));
    return tokenResult.accessToken;
  } finally {
    sessionStorage.removeItem(ENTRA_LOGIN_CONFIG_KEY);
  }
}

export function setEntraLoginError(error) {
  sessionStorage.setItem(ENTRA_LOGIN_ERROR_KEY, JSON.stringify(error || {}));
}

export function getEntraLoginError() {
  const raw = sessionStorage.getItem(ENTRA_LOGIN_ERROR_KEY);
  if (!raw) {
    return null;
  }
  sessionStorage.removeItem(ENTRA_LOGIN_ERROR_KEY);
  try {
    return JSON.parse(raw);
  } catch (e) {
    return {};
  }
}
